import {RequestOptionsType} from '../../service/api/api-type';
import {objectToUrlParameters} from '../../util/url';

export function getFetchBrandsUrl(option: RequestOptionsType): string {
    return '/v2/brands/?' + objectToUrlParameters(option);
}
